// Import SASS/SCSS styles
import 'Sass/widget.scss';

// Import Javascript dependencies
import fetchJson from 'Scripts/common/fetch-json';
import TabVisibility from 'Scripts/common/tab-visibility';

// The class
class WidgetAlert {
    constructor(baseEl) {
        this.baseEl = baseEl || document;
        this.timer;
        this.template = this.baseEl.querySelector("#widget-template");
        this.isProcessing = false;
        this.dt = this.getTimestampToNearestMinute();

        this.tab = new TabVisibility({
            callback: () => {
                this.triggerFetch();
            }
        });

        this.triggerFetch(1);
    }

    triggerFetch(delay = 0) {
        console.log("WidgetAlert.triggerFetch", {visible: this.tab.isVisible(), isProcessing: this.isProcessing, delay: delay});

        if(!this.tab.isVisible() || this.isProcessing) return;

        clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            this.fetchData();
        }, delay * 1000);
    }

    async fetchData() {
        const urlParams = new URLSearchParams(window.location.search);

        if(urlParams.get('sample') != null) {
            this.processData(window.widgetSampleData);
            return;
        }

        const { success, result } = await fetchJson("/widget/alert/data" + window.location.search + "&dt=" + this.dt, {
            method: 'POST'
        });

        this.processData(success ? result.payload : null);
    }

    async processData(data = {}, i = 1) {
        const donations = data['donations'] ?? [];
        this.dt = data['dt'];

        console.log({i: i, donations: donations[i - 1] || null, sleep: donations.length ? this.calcSleep(donations.length) : null});

        if(!donations.length) {
            const settings = this.baseEl.querySelector(".widget-settings");
            const delay = settings.dataset.delay || 10;
            this.triggerFetch(delay);
            return;
        }

        this.isProcessing = true;

        this.createDonation(donations[i - 1]);

        const widget = this.baseEl.querySelector(".widget");

        await this.sleep(this.calcSleep(donations.length));

        widget.classList.add("widget-fade-out");

        await this.sleep(.5);

        widget.remove();

        if(i < donations.length) {
            this.processData(data, i + 1);
        } else {
            this.isProcessing = false;
            this.triggerFetch(Math.max(1, 10 - data.length));
        }
    }

    createDonation(donation) {
        console.log("WidgetAlert.createDonation", donation);

        const newDonation = this.template.content.cloneNode(true);
        const amount = newDonation.querySelector(".widget-donation-amount");
        const name = newDonation.querySelector(".widget-donation-name");

        amount.appendChild(this.baseEl.createTextNode(this.formatCurrency(donation.amount)));
        name.appendChild(this.baseEl.createTextNode(donation.name));

        this.baseEl.querySelector("main").appendChild(newDonation);
    }

    formatCurrency(amount) {
        return "£" + Number(amount).toLocaleString('en', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2 
        }).replace(".00", "");
    }

    calcSleep(dataSize) {
        if(dataSize > 20) {
            return 1;
        } else if(dataSize > 10) {
            return 1.5;
        } else if(dataSize > 5) {
            return 2;
        }
        return 3;
    }

    sleep(seconds) {
        return new Promise(resolve => setTimeout(resolve, seconds * 1000));
    }

    // Get timestamp to nearest minute, as data is cached on server so makes it less unique
    getTimestampToNearestMinute() {
        const now = new Date();
        now.setSeconds(0, 0); // Set seconds and milliseconds to 0
        return now.getTime();
    }
}

// This allows widget.js to initialise the JS and pass in the shadow DOM element
window.gaylWidgetInitialise = function init(shadowDom) {
    console.log("WidgetAlert.init", shadowDom);
 
    // Cleans up global scope, but should also allow for multiple widgets on same page to reuse
    delete window.gaylWidgetInitialise;

    new WidgetAlert(shadowDom);
}

// This will only get used if accessing the widget URL directly (or if in an iframe?)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new WidgetAlert();
    });
} else if(document.currentScript) {
    new WidgetAlert();
}